import React from "react";
import SharedLayout from "./SharedLayout";
import reportChartImage from "../images/report_chart.png";
import pieChartImage from "../images/pie_chart.png";
import "../styles/PageWrappers.css";

const ExampleReportView = ({ user, onLoginClick }) => {
  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div className="example-report-wrapper">
        <h1
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            color: "#2c3e50",
            fontSize: "2rem",
          }}
        >
          Example Report
        </h1>

        <div
          style={{
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            marginBottom: "2rem",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <img
              src={reportChartImage}
              alt="Report Chart"
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            />
          </div>

          <div
            style={{
              fontSize: "1.1rem",
              lineHeight: "1.8",
              color: "#2c3e50",
            }}
          >
            <h2
              style={{
                color: "#2c3e50",
                fontSize: "1.5rem",
                marginBottom: "1.5rem",
              }}
            >
              Summary
            </h2>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                Your Anxiety score:
              </h3>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li>scores under 4.0 indicate a low probability of anxiety,</li>
                <li>
                  scores between 4.0 and 5.9 indicate a moderate probability of
                  anxiety with low negative influence on your performance,
                </li>
                <li>
                  scores over 6.0 indicate a significant probability of anxiety
                  with medium negative performance influence.
                </li>
              </ul>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                Your Depression score:
              </h3>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li>
                  scores under 4.8 indicate a low probability of depression,
                </li>
                <li>
                  scores between 4.9 and 6.5 indicate a moderate probability of
                  depression with a medium negative performance influence,
                </li>
                <li>
                  scores over 6.5 indicate a significant probability of
                  depression with high negative performance influence. You may
                  want to ask your physician about a cortisol test.
                </li>
              </ul>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                Your Genetic Predisposition score:
              </h3>
              <p style={{ marginBottom: "1rem" }}>
                Genes contain single nucleotide polymorphisms (SNPs) and
                alleles. Multiple scientific studies have implicated certain
                SNPs and alleles as playing a role in genetic predisposition
                toward anxiety and depression. SNPs/alleles have various levels
                of influence and carry different "weights" when calculating
                scores. Scores below 2 indicate low predisposition, 2-5 indicate
                medium predisposition, and scores above 5 indicate high
                predisposition. The higher your predisposition, the higher the
                negative influence on your anxiety, depression, Emotional State
                scores.
              </p>
              <p>
                While your DNA cannot be changed, the way your genes express
                themselves can. These changes are called epigenetic changes.
                Epigenetic changes are modifications to gene expression that
                don't involve alterations to the underlying DNA sequence itself.
                Think of it like adding notes or markers to a script without
                rewriting the script— the original code (your DNA) stays the
                same, but how it's read or acted out can shift. These changes
                can turn genes "on" or "off," influencing how cells function,
                develop, or respond to their environment. These changes can be
                influenced by lifestyle—diet, stress, exercise, even
                pollution—and some can be passed down to offspring, though not
                permanently like genetic mutations. Epigenetic changes are
                reversible.
              </p>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                Your Emotional State/Performance ("ESP") score:
              </h3>
              <p style={{ marginBottom: "1rem" }}>
                (ESP score is a function of Anxiety, Depression and Genetic
                Predisposition scores)
              </p>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li>
                  scores above 7.7 are significantly above baseline and indicate
                  an optimized ESP,
                </li>
                <li>
                  scores of 6.0 to 7.5 are above baseline, indicating a better
                  than average ESP, but with some room for improvement,
                </li>
                <li>
                  scores between 3.5 and 5.9 are below baseline and indicate a
                  less than optimal ESP. You should ask your physician about a
                  cortisol test,
                </li>
                <li>
                  scores between 1 and 3.4 indicate a substantial negative
                  divergence from baseline and a poor, relative ESP. You should
                  ask your physician about a cortisol test.
                </li>
              </ul>
              <p style={{ marginTop: "1rem" }}>
                ESP scores are rated based on the IZOF/Yerkes-Dodson performance
                methods (see the FAQ). Scores on the right (red) side of the
                bell curve indicate depression as the dominant underlying
                condition, with a higher negative effect on ESP scores.
              </p>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                Your ESP Contributors:
              </h3>
              <p>
                The variables within these sectors, and the relationship between
                the sectors themselves, form the foundation for your "self".
                While your genetic, childhood/youth environment and inherited
                afflictions cannot be changed, lifestyles changes can have
                epigenetic effects on your ESP going forward.
              </p>
            </section>

            <h2
              style={{
                color: "#2c3e50",
                fontSize: "1.5rem",
                marginTop: "3rem",
                marginBottom: "1.5rem",
              }}
            >
              Strategies for You
            </h2>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                1. Understanding Depression/Anxiety aspects of your current ESP
              </h3>
              <p style={{ marginBottom: "1rem" }}>
                It's important to understand that the way anxiety and depression
                affect you can be very different and knowing which one you're
                experiencing helps you find the best approach to handle it.
              </p>
              <h4 style={{ fontWeight: "500", marginBottom: "0.5rem" }}>
                Anxiety:
              </h4>
              <p style={{ marginBottom: "1rem" }}>
                Anxiety often arises from excessive worry, fear of failure, and
                a sense of urgency. To manage it, you can try techniques that
                help calm your nervous system and restore focus:
              </p>
              <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                <li>
                  Mindfulness meditation or deep breathing exercises to ease
                  tension.
                </li>
                <li>
                  Cognitive-behavioral strategies to challenge negative thinking
                  patterns.
                </li>
                <li>
                  Time management practices to help reduce overwhelm and regain
                  control.
                </li>
              </ul>
              <h4 style={{ fontWeight: "500", marginBottom: "0.5rem" }}>
                Depression:
              </h4>
              <p style={{ marginBottom: "1rem" }}>
                Depression can feel draining, making it difficult to summon
                energy or motivation, and it may leave you feeling hopeless.
                Coping with depression involves:
              </p>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li>
                  Setting small, achievable goals to create a sense of
                  accomplishment.
                </li>
                <li>
                  Seeking support through therapy or medication, if necessary.
                </li>
                <li>
                  Taking care of your body by ensuring proper sleep, exercise,
                  and maintaining social connections to reduce feelings of
                  isolation.
                </li>
              </ul>
              <p style={{ marginTop: "1rem" }}>
                Recognizing the difference between the two helps you apply the
                right methods, so you're not using strategies that might not
                address what's truly going on.
              </p>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                2. Preventing Burnout and Maintaining Your Performance
              </h3>
              <p style={{ marginBottom: "1rem" }}>
                As high performers, we often push ourselves hard, but
                misinterpreting your emotional state can lead to
                overcompensating in ways that hurt you.
              </p>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li>
                  If you're anxious but treat it as depression, you might feel
                  too tired or drained to perform, when in reality, you may just
                  need to reduce stress and manage your workload better.
                </li>
                <li>
                  If you're depressed but treat it as anxiety, you may try to
                  "power through" and force yourself to be productive, which can
                  worsen feelings of inadequacy and increase burnout.
                </li>
              </ul>
              <p style={{ marginTop: "1rem" }}>
                Understanding whether you're dealing with anxiety or depression
                helps you take action early and avoid falling into patterns of
                overworking or disengaging, which can ultimately harm your
                performance.
              </p>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                3. Improving Decision-Making and Problem-Solving
              </h3>
              <p style={{ marginBottom: "1rem" }}>
                Both anxiety and depression can affect your ability to make
                decisions, but in different ways:
              </p>
              <p style={{ marginBottom: "1rem" }}>
                <strong>Anxiety:</strong> When you're anxious, you may feel
                overwhelmed by overthinking, second-guessing, or fearing the
                consequences of making the wrong choice. You may still make
                decisions, but from a place of heightened alertness and fear of
                failure.
              </p>
              <p style={{ marginBottom: "1rem" }}>
                <strong>Depression:</strong> Depression may leave you feeling
                stuck, unsure, or unmotivated, making it hard to engage in
                problem-solving at all.
              </p>
              <p>
                By identifying whether you're feeling anxious or depressed, you
                can make decisions with more clarity—whether that means calming
                your mind when anxious or taking small, manageable steps when
                you're depressed.
              </p>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                4. Strategies for Managing Your Emotional State
              </h3>
              <div style={{ marginBottom: "1rem" }}>
                <h4 style={{ color: "#2c3e50", marginBottom: "0.5rem" }}>
                  For Anxiety:
                </h4>
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li>Practice mindfulness and deep breathing exercises</li>
                  <li>Break large tasks into smaller, manageable steps</li>
                  <li>Set realistic deadlines and expectations</li>
                  <li>Take regular breaks to prevent overwhelm</li>
                  <li>Maintain a consistent sleep schedule</li>
                </ul>
              </div>
              <div>
                <h4 style={{ color: "#2c3e50", marginBottom: "0.5rem" }}>
                  For Depression:
                </h4>
                <ul style={{ paddingLeft: "1.5rem" }}>
                  <li>Start with small, achievable goals</li>
                  <li>Maintain social connections and support systems</li>
                  <li>Engage in regular physical activity</li>
                  <li>Create a structured daily routine</li>
                  <li>Celebrate small victories and progress</li>
                </ul>
              </div>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                5. Genetic Predisposition and Environmental Factors
              </h3>
              <p style={{ marginBottom: "1rem" }}>
                Your genetic profile indicates a moderate predisposition to
                anxiety and a lower predisposition to depression. This means:
              </p>
              <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                <li>
                  You may be more sensitive to stress and environmental
                  pressures
                </li>
                <li>
                  Your body's stress response system might be more reactive
                </li>
                <li>
                  You have a natural resilience against depressive symptoms
                </li>
              </ul>
              <p>
                Remember that genetic predisposition doesn't determine your
                fate. Environmental factors and lifestyle choices play a
                significant role in managing your emotional state.
              </p>
            </section>

            <section style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  color: "#3498db",
                  fontSize: "1.2rem",
                  marginBottom: "1rem",
                }}
              >
                6. Next Steps and Resources
              </h3>
              <p style={{ marginBottom: "1rem" }}>
                Based on your results, we recommend:
              </p>
              <ol style={{ paddingLeft: "1.5rem" }}>
                <li>Schedule regular check-ins with your performance coach</li>
                <li>
                  Implement the suggested strategies that resonate with you
                </li>
                <li>Track your progress using our monitoring tools</li>
                <li>
                  Consider consulting with mental health professionals for
                  additional support
                </li>
              </ol>
            </section>

            <div
              style={{
                borderTop: "1px solid #e0e0e0",
                marginTop: "2rem",
                paddingTop: "1rem",
                fontSize: "0.9rem",
                color: "#666",
              }}
            >
              <p>
                <strong>Note:</strong> This is an example report. Your actual
                report will be personalized based on your questionnaire
                responses and genetic analysis. The strategies and
                recommendations will be tailored to your specific situation and
                needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SharedLayout>
  );
};

export default ExampleReportView;
